import { v4 as uuidv4 } from 'uuid';

export interface FinanceNonSampleCost {
  id?: uuidv4;
  instanceId: string;
  bidNumber: string;
  productName: string;
  description?: string;
  clientAmount?: number;
  vendorId?: string;
  vendorName?: string;
  vendorAmount: number;
  vendorMarkup?: number;
  lastUpdated?: Date;
}

export interface FinanceVendorSampleCost {
  id?: uuidv4;
  instanceId: string;
  bidNumber: string;
  vendorId?: string;
  blendedCpi: number;
  lastUpdated?: Date;
}

export interface FinanceSummaryOverview {
  id: uuidv4;
  instanceId: string;
  bidNumber: string;
  totalSold?: number;
  actual?: number;
  actualMargin?: number;
  soldMargin?: number;
  projectIds?: string[];
  lastUpdated?: Date;
}


// closure DTOs
export interface FinanceClosureSummary {
  id?: uuidv4;
  segments: FinanceClosureSegments[];
  bidNumber: string;
  fileLocation?: string;
  fileName?: string;
  completeCount: number;
  qcCount: number;
  invoiceDate?: Date;
  invoiceNum?: number;
  changedToCompleteCount: number;
  validationErrorMessages: ErrorDetail[];
  messages: string[];
  step1CompletedDate?: Date;
  step2CompletedDate?: Date;
  step3CompletedDate?: Date;
  step4CompletedDate?: Date;
  step5CompletedDate?: Date;
  step1CompletedBy?: string;
  step2CompletedBy?: string;
  step3CompletedBy?: string;
  step4CompletedBy?: string;
  step5CompletedBy?: string;
  note?: string;
  isSampleProjects?: boolean;
}

export interface FinanceClosureSegments {
  projectId: string;
  segment: string;
  completes: number;
  status: string;
  projectCode: string;
}

export interface FinanceClosureClientSample {
  id?: uuidv4;
  financeClosureSummaryId?: string;
  segment?: string;
  completeCount?: number;
  blendedCPI?: number;
  totalCost?: number;
  lastUpdated?: Date;
}
export interface FinanceClosureNote {
  bidNumber?: string;
  note?: string;
}
export interface FinanceVendorSendEmail {
  vendorId?: string;
  vendorName?: string;
  externalPortalUrl?: string;
  externalId?: string;
  sendEmailTo?: string;
  action?: string
}

export interface FinanceClosureVendorCost {
  id?: uuidv4;
  financeClosureVendor?: FinanceClosureVendor;
  vendorId?: string;
  segment?: string;
  completeCount?: number;
  blendedCPI?: number;
  lastUpdated?: Date;
}

export interface FinanceClosureVendor {
  id?: uuidv4;
  financeClosureSummaryId?: string;
  vendorId?: string;
  poNumber?: string;
  status?: string;
  lastUpdated?: Date;
}

export interface ErrorDetail {
  type: string;
  code: string;
  message: string;
}


